import React, { useState, useEffect, useContext, useRef } from 'react';
import { connect } from 'react-redux';
import { ObjModal } from '../../../../contexts';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


const Biz = ( { user, aid, layout, commsLoaded } ) => {
    const { obj } = useContext( ObjModal );
    const [ containerBuffer, setContainerBuffer ] = useState( 275 );
    const [ gridHeight, setGridHeight ] = useState( 0 );
    const containerRef = useRef();

    useEffect( () => {
        if ( user.additionalAccounts && user.additionalAccounts.length > 1 ) {
            setContainerBuffer( prev => prev + 30 );
        }
    }, [ user.additionalAccounts ] );

    useEffect( () => {
        setGridHeight( containerRef.current.clientHeight );
    }, [ containerBuffer ] );

    return (
        <Container fluid className='p-0' style={ { height: '100%' } }>
            <Row  style={ { height: `calc(100vh - ${containerBuffer}px)` } } ref={containerRef}>
                <Col className='p-0' xs={3} md={2} style={ { height: '100%', overflowY: 'auto' } }>
                    Biz
                </Col>
            </Row>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    user: state.user,
    aid: state.user.aid
} );
  
const mapDispatch = ( dispatch ) => ( {
    // load: dispatch.lists.loadGroups,
} );
  
export default connect( mapProps, mapDispatch )( Biz );